<template>
	<div class="wrapper">
		<div class="main">
			<div class="shop-container bgw" v-loading="loadingShow">
				<div class="tr-title">
					<template v-if="auctionInfo.label_ids">
						<el-tag effect="dark" size="mini" v-for="(item, index) in auctionInfo.label_ids" :key="index">{{ item.name }}</el-tag>
					</template>
					{{ auctionInfo.name || '' }}
				</div>

				<div class="t">
					<div class="tl">
						<div class="tl-img-box">
							<img class="play-acution" src="@/assets/images/play-circle.png" alt @click="playYoutube" v-if="auctionInfo.video_id && auctionInfo.video_id != ''" />

							<div class="youtube-player" v-show="videoShow" v-if="auctionInfo.video_id && auctionInfo.video_id != ''">
								<video-player
									style="width: 100%; height: 100%"
									class="video-player vjs-custom-skin"
									ref="videoPlayer"
									:playsinline="true"
									:options="playerOptions"
								></video-player>
							</div>
							<div class="swiper-box">
								<vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>
								<div class="des" v-if="auctionInfo.goods_categoy_desc && auctionInfo.goods_categoy_desc.categoy_desc">
									<img :src="auctionInfo.goods_categoy_desc.categoy_desc_img" />
									<span>{{ auctionInfo.goods_categoy_desc.categoy_desc }}</span>
								</div>
							</div>
						</div>
						<div class="tl-tabs">
							<div class="prev" @click="scrollPrev" :class="{ disabled: currentPicImg == 0 }">
								<i class="icon iconfont iconprev"></i>
							</div>
							<div class="next" v-if="productImgList && productImgList.length" @click="scrollNext" :class="{ disabled: currentPicImg == productImgList.length - 1 }">
								<i class="icon iconfont iconnext"></i>
							</div>
							<div class="img-list-box">
								<ul class="img-tabs" :style="{ width: ulWidth, left: ulLeft + 'px' }">
									<li v-for="(img, index) in productImgList" :key="index" @click="changeShowImg(img, index)" :class="{ active: currentPicImg == index }">
										<img v-lazy="img" alt :key="img" />
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="tr">
						<div class="tr-group" v-if="auctionInfo.auction_status == 1">
							<div class="tr-title-left">距开始:</div>
							<div class="tr-right">
								<div class="weight countdown">
									<div class="hours">
										{{ showTime.D }}
										<span>天</span>
									</div>
									<div class="hours">
										{{ showTime.H }}
										<span>时</span>
									</div>
									<div class="minutes">
										{{ showTime.M }}
										<span>分</span>
									</div>
									<div class="seconds">
										{{ showTime.S }}
										<span>秒</span>
									</div>
								</div>
							</div>
							<div class="tips-fix" style="border-left: none" @click="changeFav" :title="isFav ? '取消收藏' : '添加收藏'">
								<img v-if="!isFav" style="width: 24px; height: 24px" src="../assets/images/collect.png" alt />
								<img v-else style="width: 24px; height: 24px" src="../assets/images/collect-a.png" alt />
								<div class="tips-txt">{{ isFav ? '已收藏' : '添加收藏' }}</div>
							</div>
							<div class="tips-fix" v-if="!auctionInfo.notice" @click="notice()">
								<img class="img" src="~@/assets/images/tips2.png" alt />
								<div class="tips-txt">设置提醒</div>
							</div>
							<div class="tips-fix" v-else>
								<img class="img" src="~@/assets/images/tips2.png" alt />
								<div class="tips-txt">
									<p>已设</p>
									<p>提醒</p>
								</div>
							</div>
							<div class="quesion2">
								<el-popover placement="top-start" width="200" trigger="hover" content="“员工公益”大象公众号将第一时间推送拍卖相关信息。">
									<img slot="reference" src="../assets/images/question.png" alt />
								</el-popover>
							</div>
							<!-- <div
				  v-if="auctionInfo.end_time"
				  style="line-height: 30px"
				>截止时间：{{auctionInfo.end_time}}</div>-->
						</div>

						<div class="tr-group" v-if="auctionInfo.auction_status == 2">
							<div class="tr-title-left">距结束仅剩:</div>
							<div class="tr-right">
								<div class="weight countdown">
									<div class="hours">
										{{ showTime.D }}
										<!-- {{ auctionInfo.end_time_arr.day }} -->
										<span>天</span>
									</div>
									<div class="hours">
										{{ showTime.H }}
										<!-- {{ auctionInfo.end_time_arr.hour }} -->
										<span>时</span>
									</div>
									<div class="minutes">
										{{ showTime.M }}
										<!-- {{ auctionInfo.end_time_arr.minute }} -->
										<span>分</span>
									</div>
									<div class="seconds">
										{{ showTime.S }}
										<!-- {{ auctionInfo.end_time_arr.second }} -->
										<span>秒</span>
									</div>
								</div>

								<div v-if="auctionInfo.delay_period > 0">{{ auctionInfo.delayed_num || 0 }}次延时</div>
							</div>
							<div class="tips-fix" style="border-left: none" @click="changeFav" :title="isFav ? '取消收藏' : '添加收藏'">
								<img v-if="!isFav" style="width: 24px; height: 24px" src="../assets/images/collect.png" alt />
								<img v-else style="width: 24px; height: 24px" src="../assets/images/collect-a.png" alt />
								<div class="tips-txt">{{ isFav ? '已收藏' : '添加收藏' }}</div>
							</div>
							<div class="tips-fix" v-if="!auctionInfo.notice" @click="notice()">
								<img class="img" src="~@/assets/images/tips2.png" alt />
								<div class="tips-txt">设置提醒</div>
							</div>
							<div class="tips-fix" v-else>
								<img class="img" src="~@/assets/images/tips2.png" alt />
								<div class="tips-txt">
									<p>已设</p>
									<p>提醒</p>
								</div>
							</div>
							<div class="quesion2">
								<el-popover placement="top-start" width="200" trigger="hover" content="“员工公益”大象公众号将第一时间推送拍卖相关信息。">
									<img slot="reference" src="../assets/images/question.png" alt />
								</el-popover>
							</div>
							<!-- <div
                v-if="auctionInfo.end_time"
                style="line-height: 30px"
              >截止时间：{{auctionInfo.end_time}}</div>-->
						</div>
						<div class="tr-price tr-group">
							<div class="tr-title-left">当前价</div>
							<div class="tr-right">
								<span class="now-price">
									<i>￥</i>
									<span class="price-num">{{ auctionInfo.current_price || '0.00' }}</span>
								</span>
							</div>

							<div v-if="auctionInfo.end_time_arr && auctionInfo.auction_status != 1" style="line-height: 30px">
								截止时间： {{ auctionInfo.end_time_arr }}
								<div
									style="display: initial; padding-left: 4px"
									v-if="auctionInfo.auction_status == 3 || auctionInfo.auction_status == 4 || auctionInfo.auction_status == 5 || auctionInfo.auction_status == 6"
								>
									{{ auctionInfo.delayed_num || 0 }}次延时
								</div>
							</div>
							<div v-else="auctionInfo.end_time" style="line-height: 30px">截止时间：{{ auctionInfo.end_time }}</div>
						</div>

						<div class="mt-auction">
							<!--auction_status:  竞拍状态，1竞拍未开始，2竞拍开始，3竞拍成功，4竞拍失败，5竞拍生成订单 -->
							<!--is_enroll:  是否报名，1报名， 2未报名 -->
							<!-- 未开始 -->

							<div class="auction-pannel" v-if="auctionInfo.auction_status == 1">
								<div class="end-status">
									<img class="img" src="../assets/images/mt2.png" alt />
									即将开始
								</div>
							</div>

							<!-- 正在进行 -->
							<div class="auction-pannel" v-if="auctionInfo.auction_status == 2">
								<div class="auction-status">正在进行</div>

								<div class="quesion">
									<el-popover placement="top-start" width="200" trigger="hover" content="请按照加价幅度填写你要输入的价格。">
										<img slot="reference" src="../assets/images/question.png" alt />
									</el-popover>
								</div>

								<div class="tr-price tr-group pay-btn-wrap">
									<!-- <div class="tr-title-left"></div> -->

									<!-- 立即报名 -->
									<div class="tr-right" v-if="auctionInfo.auction_status == 2 && auctionInfo.is_enroll == '2' && auctionInfo.need_bond == 1">
										<el-button class="pay-btn" @click="submitHandler">
											<div class="line1">立即报名</div>
											<div class="line2">保证金 ￥{{ auctionInfo.bond_money || '0.00' }}</div>
										</el-button>
										<!-- <div class="tips"><img class="img" src="~@/assets/images/tips1.png" alt=""> 如何交钱报名</div> -->
									</div>
									<!-- 立即出价 -->
									<div class="tr-right input-number" v-if="auctionInfo.auction_status == 2 && auctionInfo.is_enroll == '1'">
										<el-input-number
											v-model="current_auction_price"
											v-if="auctionInfo.increase_top_price"
											@change="handleChange"
											:min="last_auction_price"
											:precision="2"
											:step="auctionInfo.increase_price"
										></el-input-number>
										<!-- :max="auctionInfo.increase_top_price"
                    -->
										<el-input-number
											v-model="current_auction_price"
											@change="handleChange"
											:min="last_auction_price"
											:precision="2"
											v-else
											:step="auctionInfo.increase_price"
										></el-input-number>

										<div style="display: flex; align-items: center">
											<el-button class="pay-btn" @click="anonymousOffer" v-if="!auctionTimeStatus">
												<div class="line1">匿名出价</div>
											</el-button>
											<el-button class="pay-btn" @click="normalOffer" v-if="!auctionTimeStatus" style="background-color: #fd631a">
												<div class="line1">立即出价</div>
											</el-button>
											<el-button class="pay-btn" v-if="auctionTimeStatus">
												<div class="line1">结算中，请稍后</div>
											</el-button>
											<div
												class="offer-action-link line1"
												@click="copyInviteUrl"
												title="点击复制分享链接"
											>
												<img src="@/assets/images/share.svg" />
												分享邀请
											</div>
											<div
												v-if="auctionInfo.auction_auto_price == 1"
												class="offer-action-link line1"
												@click="openAutoOfferDialog"
											>
												<img src="@/assets/images/auction.png" />
												出价设置
											</div>
										</div>
									</div>
								</div>

								<div class="tr-price tr-group" v-if="auctionInfo.is_enroll == 2">
									<!-- <div class="tr-title-left"></div> -->
									<div class="tr-right">
										<div class="bot-tips" v-if="auctionInfo.bond_money > 0">
											<span>提醒：</span>
											您还没有报名交保证金，报名成功后再
											<span>出价</span>
										</div>
										<div class="bot-tips" v-else>
											<span>提醒：</span>
											本商品无需缴纳保证金
										</div>
									</div>
								</div>
							</div>

							<!-- 结束 -->
							<div
								class="auction-pannel"
								v-if="
									auctionInfo.auction_status == 1 ||
									auctionInfo.auction_status == 3 ||
									auctionInfo.auction_status == 4 ||
									auctionInfo.auction_status == 5 ||
									auctionInfo.auction_status == 6
								"
							>
								<div class="end-status" v-show="auctionInfo.auction_status != 1 && auctionInfo.auction_status != 2">
									<img class="img" src="../assets/images/mt2.png" alt />
									本场次已结束
								</div>
								<div class="auction-end-user" v-if="auctionInfo.auction_status == 3 || auctionInfo.auction_status == 5 || auctionInfo.auction_status == 6">
									<div class="user-txt" @click="otherAuction()">看看其它拍卖</div>
								</div>

								<!-- <div class="auction-end-user" v-if="(auctionInfo.auction_status == 3 && auctionInfo.pay_timeout_second>0) && auctionInfo.success_offer_current_user"><div class="user-txt">恭喜竞拍成功</div></div>
                <div class="auction-end-user" v-if="(auctionInfo.auction_status == 3 && auctionInfo.pay_timeout_second<=0) && auctionInfo.success_offer_current_user"><div class="user-txt">超时未付款</div></div>-->
							</div>

							<div class="auction-pannel" v-if="auctionInfo.auction_status == 4">
								<div class="auction-end-user">
									<div class="user-txt" @click="otherAuction()">竞拍失败，看看其它拍卖</div>
								</div>
							</div>
						</div>
						<div class="mt-list">
							<div class="mt-list-top">
								<div class="l">
									<div class="auction-icon">
										<img src="../assets/images/mt1.png" alt />
									</div>
									爱心拍卖
								</div>
								<div class="r">
									<div class="user">
										<span>{{ auctionInfo.enroll_num || 0 }}</span>
										人次出价
									</div>
									<div class="user-tips" v-if="auctionInfo.watch_num > 0">
										<span>{{ auctionInfo.watch_num || 0 }}</span>
										人次围观
									</div>
								</div>
							</div>

							<div class="mt-list-bot">
								<div class="bot-item" v-if="auctionInfo.need_bond == 1">保证金：￥{{ auctionInfo.bond_money || '0.00' }}</div>
								<!-- <div class="bot-item" v-if="auctionInfo.need_bond != 1">保证金：无</div>-->
								<div class="bot-item" v-if="auctionInfo.evaluation_price > 0">评估价：￥{{ auctionInfo.evaluation_price }}</div>
								<div class="bot-item" v-if="auctionInfo.auction_cycle > 0">竞价周期：{{ auctionInfo.auction_cycle || 0 }}天</div>
								<div class="bot-item" v-if="auctionInfo.start_price > 0">起拍价：￥{{ auctionInfo.start_price || '0.00' }}</div>
								<div class="bot-item" v-if="auctionInfo.delay_period > 0">
									延时周期： {{ auctionInfo.delay_period }}分钟/次
									<el-popover
										placement="top-start"
										width="200"
										trigger="hover"
										:content="`当距离竞价结束时间小于等于${auctionInfo.delay_period}分钟时，如有新的出价，则从出价时间点开始重新延时${auctionInfo.delay_period}分钟。直至${auctionInfo.delay_period}分钟之内无人出价，最高价中标。`"
									>
										<img slot="reference" style="width: 20px; height: 20px" src="../assets/images/question.png" alt />
									</el-popover>
								</div>
								<div class="bot-item" v-if="auctionInfo.increase_price > 0">加价幅度：￥{{ toDecimal2(auctionInfo.increase_price) || '0.00' }}</div>
								<div class="bot-item" v-if="auctionInfo.old_increase_top_price > 0">单次最高加价幅度：￥{{ auctionInfo.old_increase_top_price || '0.00' }}</div>
							</div>
							<div class="mt-list-bot" v-if="auctionInfo.auction_aftersales_desc">
								<div class="aftersales-desc">售后说明：{{ auctionInfo.auction_aftersales_desc }}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 自动出价设置弹窗 -->
				<el-dialog title="自动出价设置" :visible.sync="autoOfferVisible" width="420px">
					<div class="auto-offer-dialog">
						<el-form :model="autoOfferForm" label-width="96px">
							<el-form-item label="开启自动出价">
								<el-switch v-model="autoOfferForm.is_open"></el-switch>
							</el-form-item>
							<el-form-item label="最高预期价格">
								<el-input v-model="autoOfferForm.max_price" placeholder="请输入最高预期价格"></el-input>
							</el-form-item>
							<el-form-item label="加价幅度">
								<el-input v-model="autoOfferForm.step_price" placeholder="必须是10的倍数"></el-input>
							</el-form-item>
							<el-form-item>
								<el-checkbox v-model="autoOfferForm.agree_protocol">我已阅读并同意</el-checkbox>
								<a :href="autoOfferProtocolUrl" target="_blank" style="margin-left: 6px; color: #409eff">《自动出价说明》</a>
							</el-form-item>
						</el-form>
						<div class="dialog-footer" style="text-align: right; margin-top: 20px">
							<el-button @click="autoOfferVisible = false">关闭</el-button>
							<el-button type="primary" @click="saveAutoOffer">保存设置</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 相似拍品推荐 -->
			<div class="similar-auc-wrapper" v-if="similarList && similarList.length">
				<div class="similar-auc-header">
					<span class="similar-auc-title">相似拍品推荐</span>
				</div>
				<div class="similar-auc-content">
					<div class="similar-arrow left" :class="{ disabled: !similarCanPrev }" @click="prevSimilar">
						<i class="icon iconfont iconprev"></i>
					</div>
					<div class="similar-auc-list">
						<div class="similar-auc-item" v-for="item in visibleSimilar" :key="item.id" @click="toDetails(item.id)">
							<div class="img">
								<img :src="item.cover_img" alt />
								<div class="similar-status todo" v-if="item.auction_status == 1">未开始</div>
								<div class="similar-status doing" v-else-if="item.auction_status == 2">竞拍中</div>
								<div class="similar-status done" v-else-if="item.auction_status == 3 || item.auction_status == 5">已结束</div>
								<div class="similar-status fail" v-else-if="item.auction_status == 4">流拍</div>
							</div>
							<div class="info">
								<div class="name" :title="item.name">{{ item.name }}</div>
								<div class="price">
									<span class="label">当前价</span>
									<span class="value">￥{{ item.latest_price || 0 }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="similar-arrow right" :class="{ disabled: !similarCanNext }" @click="nextSimilar">
						<i class="icon iconfont iconnext"></i>
					</div>
				</div>
			</div>

			<div class="bot-content-wrap">
				<div class="b" style="position: relative">
					<div class="tabs">
						<div class="tab" v-for="(item, index) in tabTitleArr" :key="index" @click="returnTo(item.id)" :class="{ active: tabIndex == index }">{{ item.name }}</div>
					</div>
					<div style="background: #fff">
						<div class="leaderboard">
							<div class="title bgf6">扫码出价</div>
							<div class="qr-txt-wrap">
								<div id="qrcode" ref="qrcode"></div>
								<div class="qrcode-desc">大象扫一扫</div>
								<div class="qrcode-desc">手机上随时随地出价</div>
							</div>

							<div class="title">热门推荐</div>
							<div class="board">
								<div class="item" v-for="(item, index) in saleRanking" :key="index" @click="toDetails(item.id)">
									<div class="img">
										<img v-lazy="item.cover_img" alt />
									</div>
									<div class="info">
										<div class="name">{{ item.name }}</div>
										<div class="price" v-if="item.auction_status == 1">
											<span class="txt">起拍价</span>
											￥{{ item.start_price || '0.00' }}
										</div>

										<div class="price" v-if="item.auction_status == 2">
											<span class="txt">当前价</span>
											￥{{ item.current_auction_price || '0.00' }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="shop-info-wrap">
							<div id="detail">
								<div class="progress">
									<div class="progress-title">竞拍流程</div>
									<div class="progress-item">报名参与</div>
									<img class="img" src="~@/assets/images/arrow.png" alt />
									<div class="progress-item">出价竞拍</div>
									<img class="img" src="~@/assets/images/arrow.png" alt />
									<div class="progress-item">竞价成功</div>
									<img class="img" src="~@/assets/images/arrow.png" alt />
									<div class="progress-item">支付货款</div>
									<img class="img" src="~@/assets/images/arrow.png" alt />
									<div class="progress-item">拍品履约</div>
								</div>
								<div class="params-wrap" v-if="goodsParams">
									<!-- <h3>
										<img class="sign" src="~@/assets/images/sign.png" alt="" />
										商品介绍
										<img class="sign sign2" src="~@/assets/images/sign.png" alt="" />
                  </h3>-->
									<div v-for="(item, index) in goodsParams" :key="index" class="params-content">{{ item.name }}：{{ item.value }}</div>
								</div>
								<div class="shop-info-item" v-show="tabIndex == 0" v-html="auctionInfo.desc"></div>
							</div>
							<div class="comment-auction-wrap" id="list">
								<div class="params-wrap">
									<h3>
										<img class="sign" src="~@/assets/images/sign.png" alt />
										出价记录
										<img class="sign sign2" src="~@/assets/images/sign.png" alt />
									</h3>
								</div>

								<el-table
									height="400"
									:data="auctionInfo.log"
									ref="table"
									style="width: 100%"
									v-if="!auctionIng && (auctionInfo.auction_status == 3 || auctionInfo.auction_status == 4 || auctionInfo.auction_status == 5)"
									max-height="700"
								>
									<el-table-column label="状态">
										<template slot-scope="scope">
											<el-button type="text" size="small" class="tab-btn" v-if="scope.row.offer_status != 1">{{ scope.row.offer_desc }}</el-button>
											<el-button type="text" size="small" class="tab-btn active" v-if="scope.row.offer_status == 1">{{ scope.row.offer_desc }}</el-button>
										</template>
									</el-table-column>
									<el-table-column prop="userInfo.nickname" label="姓名" width="180"></el-table-column>
									<el-table-column prop="current_auction_price" label="价格"></el-table-column>
									<el-table-column prop="ctime" label="时间"></el-table-column>
								</el-table>
								<el-table
									height="400"
									ref="table"
									:data="auctionInfo.log"
									style="width: 100%"
									v-else-if="auctionIng || auctionInfo.auction_status == 1 || auctionInfo.auction_status == 2"
									max-height="700"
								>
									<el-table-column label="状态">
										<template slot-scope="scope">
											<el-button type="text" size="small" class="tab-btn" v-if="scope.$index != 0">被超越</el-button>
											<el-button type="text" size="small" class="tab-btn active" v-else-if="scope.$index == 0">领先</el-button>
										</template>
									</el-table-column>
									<el-table-column prop="userInfo.nickname" label="姓名" width="180"></el-table-column>
									<el-table-column prop="current_auction_price" label="价格"></el-table-column>
									<el-table-column prop="ctime" label="时间"></el-table-column>
								</el-table>
							</div>
							<div class="comment-auction-wrap" id="notice" v-if="auctionInfo.need_bond == 1">
								<div class="params-wrap" v-if="auctionInfo.need_bond == 1">
									<h3>
										<img class="sign" src="~@/assets/images/sign.png" alt />
										保证金须知
										<img class="sign sign2" src="~@/assets/images/sign.png" alt />
									</h3>
								</div>
								<div v-html="auctionInfo.auction_bond_desc"></div>
							</div>
							<div class="comment-auction-wrap" id="more" v-if="auctionInfo.auction_desc_notice">
								<div class="params-wrap">
									<h3>
										<img class="sign" src="~@/assets/images/sign.png" alt />
										拍卖须知
										<img class="sign sign2" src="~@/assets/images/sign.png" alt />
									</h3>
								</div>
								<div class="auction_desc_notice">
									<img :src="auctionInfo.auction_desc_notice" alt="" />
								</div>
							</div>

							<div class="params-wrap" id="msg">
								<h3>
									<img class="sign" src="~@/assets/images/sign.png" alt />
									评论区
									<img class="sign sign2" src="~@/assets/images/sign.png" alt />
								</h3>
							</div>
							<msg-list :relId="goodsId" type="2" v-if="goodsId != ''" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition name="el-fade-in">
			<div class="scrollTop" v-show="toTopShow" @click="scrollToTop">
				<i class="icon iconfont iconfanhuidingbu"></i>
				<p>顶部</p>
			</div>
		</transition>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="600px">
			<div class="dia">
				<div v-if="showTime2.D <= 0 && showTime2.H <= 0 && showTime2.M <= 0 && showTime2.S <= 0">
					<div class="dia-title">竞价失败！</div>
					<div class="dia-desc">由于您逾期未支付，您已放弃购买。</div>
				</div>
				<div v-else-if="showTime2.D > 0 || showTime2.H > 0 || showTime2.M > 0 || showTime2.S > 0">
					<div class="dia-title">竞价成功！</div>
					<div class="dia-desc">请您及时支付！逾期未支付者视为放弃购买。</div>
				</div>

				<div class="countdown" v-if="showTime2.D > 0 || showTime2.H > 0 || showTime2.M > 0 || showTime2.S > 0">
					<div class="hours">
						{{ showTime2.D }}
						<span>天</span>
					</div>
					<div class="hours">
						{{ showTime2.H }}
						<span>时</span>
					</div>
					<div class="minutes">
						{{ showTime2.M }}
						<span>分</span>
					</div>
					<div class="seconds">
						{{ showTime2.S }}
						<span>秒</span>
					</div>
				</div>
				<div class="dia-btn-wrap">
					<div class="dia-btn cancel" @click="cancle" v-if="(showTime2.D > 0 || showTime2.H > 0 || showTime2.M > 0 || showTime2.S > 0) && !isAutoWin">放弃购买</div>
					<div class="dia-btn" @click="buyNow" v-if="showTime2.D > 0 || showTime2.H > 0 || showTime2.M > 0 || showTime2.S > 0">支付购买</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="恭喜出价成功！可保存图片转发朋友圈哦！" :visible.sync="shareWelfare" width="420px" class="sharePoster">
			<div class="dia">
				<div>
					<img :src="sharePoster" style="max-width: 400px" />
					<div class="poster-tips">注：如果无法下载，可右键另存为</div>
					<div class="dia-desc" style="text-align: -webkit-center" @click="savePoster()">
						<div class="dia-btn">保存图片</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="温馨提示" :visible.sync="showAuctionTips" width="420px" class="showAuctionTips">
			<div class="dia">
				<div class="dia-content">
					<div class="poster-tips">请核实出价金额，点击确认后将自动参与竞拍，是否确认？</div>

					<div class="dia-desc" style="">
						<div class="dia-btn" @click="confirmOffer()">确定</div>
						<div class="dia-btn cancle" @click="cancleOffer()">取消</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<div style="display: none" v-if="sharePoster">
			<img :src="sharePoster" />
		</div>
		<!-- <msg :relId="goodsId" type="2" v-if="goodsId !='' "/> -->
	</div>
</template>

<script>
import vueMagnify from '@/components/vue-magnify/index.vue';
import { timeToDate, moneySub, toDecimal, toDecimal2 } from '@/utils';
import { mapActions } from 'vuex';
import QRCode from 'qrcodejs2';
import { apiBaseUrl, websocketUrl, autoOfferProtocolUrl } from '@/config/env.js';
// import Msg from '../components/msg.vue';
import MsgList from '@/components/msg/MsgList.vue';

import { showLoading, hideLoading } from '../utils/loading';
import throttle from 'lodash.throttle';

import Ws from '@/config/ws.js';
import { autoOfferInfo, autoOfferSave } from '@/config/http.js';
import { isSafeRedirect } from '@/utils';

export default {
	name: 'ProductDetail',
	components: { vueMagnify, MsgList },
	inject: ['reload'],
	data() {
		return {
			playerOptions: {
				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, //如果true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						// type: "application/x-mpegURL",
						// video/mp4
						//src: 'https://s3plus.sankuai.com/yangguangyimai-prod/static/uploads/video/2021/12/16/163964486961bafec60fab2.mp4' //url地址
						src: '' //url地址
					}
				],
				poster: '', //你的封面地址
				// notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					fullscreenToggle: true //全屏按钮
				}
			},
			videoShow: false,
			lastOfferTime: '',
			auctionStatus: 'end',
			dialogVisible: false,
			shareWelfare: false,
			
			tableData: [
				{
					date: '2016-05-02',
					price: '2323',
					num: 'H9184',
					status: 1
				},
				{
					date: '2016-05-02',
					price: '2323',
					num: 'H9184',
					status: 0
				}
			],
			num: 10,
			toTopShow: false,
			buyNum: 1,
			tabTitleArr: [
				{
					id: 'detail',
					name: '拍品介绍'
				} /* 
        {
          id: 'tips2',
          name: '竞买须知',
        }, */,
				{
					id: 'list',
					name: '出价记录'
				}
			],
			tabIndex: 0,
			goodsId: '',
			imgList: [],
			ulLeft: 0,
			isEnd: false,
			goodsInfo: {}, //商详情
			product: {}, // 规格详情
			isFav: false, //收藏
			goodsParams: null, //商品参数信息
			goodsComments: {
				count: 0,
				page: 1,
				limit: 15,
				list: null
			}, // 商品评论信息, //商品评论信息
			currentImg: '', //列表选中图片
			selectCommentImg: '', //评论选中图片
			selectCommentImgIndex: null, //评论选中图片
			selectCommentIndex: null, //评论选中图片
			loadingShow: false,
			saleRanking: [], //销量排行榜
			showTime: {
				D: 0,
				H: 0,
				M: 0,
				S: 0
			}, //倒计时
			auctionTimeStatus: false, //倒计时结束
			// 相似拍品推荐列表起始索引与每页数量
			similarIndex: 0,
			similarPageSize: 4,
			showTime2: {
				D: 0,
				H: 0,
				M: 0,
				S: 0
			}, //倒计时
			auctionInfo: {},
			timeoutID: null,
			interval: null,
			interval2: null,
			last_auction_price: '',
			current_auction_price: '',
			currentPicImg: 0,
			auctionIng: false, //是否竞拍中
			logForm: {
				page: 2,
				limit: 10
			},
			logEND: false,
			loadScroll: false,
			socket: null, //websock客户端
			sharePoster: '', //分享图片
			showAuctionTips: false,
			anonymous: 2, //是否匿名出价
			autoOfferVisible: false,
			autoOfferProtocolUrl,
			autoOfferForm: {
				is_open: true,
				max_price: '',
				step_price: '',
				agree_protocol: false
			},
			invite: ''
		};
	},
	watch: {
		$route(to) {
			// if (to.name == 'detail') {
			//   let goodsId = this.$route.params.goodsId
			//   if (goodsId) {
			//     this.goodsId = goodsId
			//     this.getAllInfo()
			//   }
			// }
			// if (this.$route) {
			//   this.buyNum=1
			// }
			// this.getAuctionInfo(this.goodsId)
		},
		auctionInfo: {
			handler() {
				//this.timeoutUpdateLog();
			},
			deep: true
		}
	},
	computed: {
		inviteUrl() {
			if (!this.invite || !this.goodsId) return '';
			return `${apiBaseUrl}web/auction/${this.goodsId}?invitecode=${this.invite}`;
		},
		ulWidth() {
			if (this.auctionInfo.images_path) {
				return this.auctionInfo.images_path.length * 62 + 'px';
			}
			return 0 + 'px';
		},
		prevDisabled() {
			return this.ulLeft == 0;
		},
		nextDisabled() {
			if (this.auctionInfo.images_path) {
				return this.auctionInfo.images_path <= 5 || this.isEnd;
			}
			return false;
		},
		buyMax() {
			return this.product.stock;
		},
		productImgList() {
			return this.auctionInfo.images_path;
		},
		// 相似拍品完整列表
		similarList() {
			if (this.auctionInfo && this.auctionInfo.similar_auctions && this.auctionInfo.similar_auctions.list) {
				return this.auctionInfo.similar_auctions.list;
			}
			return [];
		},
		// 当前展示的相似拍品
		visibleSimilar() {
			if (!this.similarList || !this.similarList.length) {
				return [];
			}
			return this.similarList.slice(this.similarIndex, this.similarIndex + this.similarPageSize);
		},
		similarCanPrev() {
			return this.similarIndex > 0;
		},
		similarCanNext() {
			return this.similarIndex + this.similarPageSize < this.similarList.length;
		},
		isAutoWin() {
			// 是否自动出价中标：以中标记录 auction_success_offer.is_auto 为准
			if (this.auctionInfo && this.auctionInfo.auction_success_offer) {
				return this.auctionInfo.auction_success_offer.is_auto === 1;
			}
			return false;
		}
	},
	methods: {
		// 工具方法映射，便于在模板中直接调用
		toDecimal2,
		...mapActions(['getCartNumsAction']),

		recordInviteVisit() {
			const code = this.$storage.get('invitecode');
			if (!code && !this.$storage.get("userToken")) return 
			return this.$api.recordInviteActivityVisit({
				code,
				visited_page: `${apiBaseUrl}web/`
			}).then(() => {
				this.$storage.remove('invitecode');
			});
		},
		//连接websocket
		openWebsocket() {
			let _this = this;
			if (!_this.socket || _this.socket == null) {
				_this.socket = new Ws({
					url: websocketUrl,
					Heartbeat_s: 10000, //默认心跳时间，单位毫秒
					reconnect_s: 2000, //默认重连时间，单位毫秒
					content: {
						//订阅
						event: 'bind',
						data: { auction_id: this.goodsId }
					},
					success: function (res) {
						_this.callback(res);
					}
				});
			}
		},
		//websocket回调地址
		callback(res) {
			if (res.event == 'get_last_log') {
				this.updateAuctionPrice(res);
			} else if (res.event == 'auction_offer') {
				this.updateAuctionAuctionOffer(res);
			} else if (res.event == 'notice_auction_success_user') {
				if (res.data.id == this.goodsId) {
					this.showPayInfo(res.data);
				}
			} else if (res.event == 'notice_auction_success_other_user') {
				if (res.data.id == this.goodsId) {
					this.auctionInfo.auction_status = res.data.auction_status;

					this.auctionIng = true;
					if (res.data.auction_status == 3) {
						//结束了，就关了吧
						this.socket && this.socket.close();
					}
				}
			} else if (res.event == 'auction_start') {
				//告诉所有用户，开始了，可以竞拍了
				if (res.data.id == this.goodsId) {
					this.auctionInfo.auction_status = res.data.auction_status;
					this.auctionIng = true;
					this.auctionTimeStatus = false;
					this.showTimes();
					//自动报名
					this.submitHandler();
				}
			}
		},
		//刷新价格
		updateAuctionPrice(res) {
			if (res && res.status && res.data && res.data.info) {
				let auctionInfo = res.data.info;
				if (auctionInfo.id != this.goodsId) {
					return true;
				}
				let auctionLog = res.data.log;

				this.showPayInfo(auctionInfo);
				this.getAuctionIsIng(auctionInfo['auction_status']);
				//刷新当前价以及出价记录、和倒计时
				this.auctionInfo.current_price = auctionInfo.current_price;
				this.auctionInfo.old_increase_top_price = auctionInfo.increase_top_price;
				if (Number(auctionInfo.increase_top_price) > 0) {
					this.auctionInfo.increase_top_price = Number(auctionInfo.current_price) + Number(auctionInfo.increase_top_price);
				} else {
					this.auctionInfo.increase_top_price = 0;
				}
				this.calculationCurrent(auctionInfo);
				//判断是否竞拍中
				this.getAuctionIsIng(this.auctionInfo['auction_status']);

				this.auctionInfo.auction_status = auctionInfo.auction_status;
				this.auctionInfo.end_time_arr = auctionInfo.end_time_arr; //更新时间
				this.auctionInfo.delayed_num = auctionInfo.delayed_num; //更新延时次数
				//this.auctionInfo.user_enroll = auctionInfo.user_enroll;
				//this.auctionInfo.is_enroll = auctionInfo.is_enroll;
				this.auctionInfo.pay_timeout = auctionInfo.pay_timeout;
				this.auctionInfo.pay_timeout_origin = auctionInfo.pay_timeout_origin;
				this.auctionInfo.success_offer_current_user = auctionInfo.success_offer_current_user;
				this.auctionInfo.offer_log_num = auctionInfo.offer_log_num; //延期次数

				if (auctionLog.id) {
					this.addAction(auctionLog);
					this.last_log_id = auctionLog.id;
					if (auctionLog.userInfo.id != this.auctionInfo.log[0].userInfo.id) {
						this.lastOfferTime = -1; //频繁操作解锁
					}
				}
				this.showTimes();
			}
		},
		//刷新出价返回值
		updateAuctionAuctionOffer(res) {
			if (res.data.auction_id == this.goodsId) {
				//this.$common.errorToShow(res.msg);
				this.$message({
					message: res.msg,
					type: res.status ? 'success' : 'error'
				});
				if (res.status && res.data) {
					this.last_auction_price = this.current_auction_price =
						((Number(res.data.current_price) * 1000 + Number(this.auctionInfo.increase_price) * 1000) / 1000).toFixed(2) - 0;
					//this.last_auction_price = this.current_auction_price = Number(this.$common.moneySum(res.data.current_price, this.auctionInfo.increase_price)).toFixed(2);
					this.lastOfferTime = this.getNowTime();
				}
			}
		},

		openAutoOfferDialog() {
			if (!this.$storage.get('userToken')) {
				this.$message.warning('请先登录');
				return;
			}
			if (!this.auctionInfo || !this.auctionInfo.id) return;

			autoOfferInfo({ auction_id: this.auctionInfo.id }).then((res) => {
				if (res.status && res.data) {
					this.autoOfferForm.is_open = res.data.is_open == 1;
					this.autoOfferForm.max_price = res.data.max_price || '';
					this.autoOfferForm.step_price = res.data.step_price || '';
				}
				this.autoOfferVisible = true;
			});
		},

		saveAutoOffer() {
			const f = this.autoOfferForm;
			if (!f.agree_protocol) {
				this.$message.warning('请先勾选阅读并同意自动出价说明');
				return;
			}
			const max = parseFloat(f.max_price);
			const step = parseFloat(f.step_price);
			if (f.is_open) {
				if (isNaN(max) || max <= 0) {
					this.$message.error('请输入正确的最高预期价格');
					return;
				}
				if (isNaN(step) || step <= 0 || step % this.auctionInfo.increase_price !== 0) {
					this.$message.error('加价幅度必须是拍品加价幅度（' + this.auctionInfo.increase_price + '）的整数倍');
					return;
				}
			}

			autoOfferSave({
				auction_id: this.auctionInfo.id,
				max_price: max,
				step_price: step,
				is_open: f.is_open ? 1 : 0,
				agree_protocol: f.agree_protocol ? 1 : 0
			}).then((res) => {
				if (res.status) {
					this.$message.success(res.msg || '保存成功');
					this.autoOfferVisible = false;
				} else {
					this.$message.error(res.msg || '保存失败');
				}
			});
		},

		playYoutube() {
			this.videoShow = true;
			this.$nextTick(() => {
				this.$refs.videoPlayer.player.play();
			});
		},

		cancle() {
			const _this = this;
			_this.auctionIng = false;
			let msg = '是否确定放弃本次竞拍成功资格？竞拍善款将全额捐赠给美团袋鼠宝贝公益计划，为骑手等新就业群体家庭子女提供公益支持。';
			if (_this.auctionInfo.need_bond == 1) {
				msg = '是否真的放弃竞拍成功资格？若放弃竞拍保证金将不予退回，且本场拍卖弃拍/逾期拍不得超过3次，3次以上将无法参与后续拍卖。';
			}
			this.$confirm(msg).then((_) => {
				_this.$api.giveUpAuction({ auction_id: _this.goodsId }).then((res) => {
					_this.dialogVisible = false;
					clearInterval(_this.interval2);
					if (!res.status) {
						this.$message({
							message: res.msg,
							type: 'error'
						});
						return;
					}
				});
			});
		},
		qrcode() {
			let qrcode = new QRCode('qrcode', {
				width: 200, // 二维码宽度，单位像素
				height: 200, // 二维码高度，单位像素
				text: `${apiBaseUrl}wap/pageauction/index/index?id=${this.goodsId}` // 生成二维码的链接
			});
		},
		//
		buyNow() {
			if (this.auctionInfo.success_offer_current_user) {
				let data = {
					product_id: this.auctionInfo.product_id,
					nums: 1,
					type: 2,
					order_type: 12, //拍卖
					params: JSON.stringify({ auction_id: this.goodsId })
				};
				this.$api.addCart(data).then((res) => {
					if (res.status) {
						this.dialogVisible = false;
						let cartIds = res.data;
						this.$router.push({
							name: 'order',
							query: {
								cart_ids: JSON.stringify(cartIds),
								ordertype: 12,
								auctionid: this.goodsId
							}
						});
					} else {
						this.dialogVisible = false;
						this.$message({
							message: res.msg,
							type: 'error'
						});
						return;
					}
				});
			}
		},

		getNowTime() {
			return parseInt(new Date().getTime() / 1000);
		},
		//匿名出价
		anonymousOffer() {
			this.anonymous = 1;
			this.submitPay();
		},
		//正常出价
		normalOffer() {
			this.anonymous = 2;
			this.submitPay();
		},
		// 立即出价
		submitPay() {
			if (!this.$storage.get('firstEnrollAuction_' + this.goodsId)) {
				this.showAuctionTips = true;
				return;
			}
			let now = this.getNowTime();
			if (now - this.lastOfferTime <= 1) {
				//1秒的时间间隔，防止频繁出价
				this.$message({
					message: '请勿频繁操作~',
					type: 'error'
				});
				return;
			}
			// 计算本次加价幅度
			let differencePrice = moneySub(this.current_auction_price, this.auctionInfo.current_price);
			//检查是否有加价幅度,并且出价是否正确
			if (this.auctionInfo.increase_price && this.auctionInfo.increase_price !== '' && this.auctionInfo.increase_price !== 0) {
				let priceResult = differencePrice % parseFloat(this.auctionInfo.increase_price).toFixed(2);
				if (priceResult !== 0) {
					this.$message({
						message: '请输入加价幅度' + this.auctionInfo.increase_price + '的倍数',
						type: 'error'
					});
					return;
				}
			}
			//检查封顶价
			if (this.auctionInfo.increase_top_price && this.auctionInfo.increase_top_price !== '' && this.auctionInfo.increase_top_price !== 0) {
				if (toDecimal(this.current_auction_price) > toDecimal(this.auctionInfo.increase_top_price)) {
					this.$message({
						message: '加价幅度不能超过加价封顶价￥' + this.auctionInfo.increase_top_price + '',
						type: 'error'
					});
					return;
				}
			}
			// 加价幅度超过1000 且 未设定保证金时二次确认
			if (Number(differencePrice) > 1000 && this.auctionInfo.need_bond === 2) {
				this.$confirm('您本次出价加价幅度超过1000，请确认是否出价').then(() => {
					this.doSubmitPay();
				});
				return;
			}
			// 直接提交出价
			this.doSubmitPay();
		},
		// 执行实际出价
		doSubmitPay() {
			let data = {
				id: this.goodsId,
				current_auction_price: this.current_auction_price,
				anonymous: this.anonymous
			};
			this.$api.auctionOffer(data).then((res) => {
				this.$message({
					message: res.msg,
					type: res.status ? 'success' : 'error'
				});

				if (res.status) {
					this.lastOfferTime = this.getNowTime();
					//this.last_auction_price = this.current_auction_price =
						((Number(res.data.current_price) * 1000 + Number(this.auctionInfo.increase_price) * 1000) / 1000).toFixed(2) - 0;

					this.createShareWelfare();
				}
			});
		},
		//立即报名
		submitHandler() {
			if (!this.auctionInfo.user_enroll) {
				this.$api.auctionEnroll({ id: this.goodsId }).then((res) => {
					if (res.status) {
						if (this.auctionInfo.bond_money > 0) {
							this.$router.replace({
								name: 'cashier',
								params: {
									order_id: res.data.id,
									type: 10,
									money: this.auctionInfo.bond_money,
									goodsId: this.goodsId
								}
							});
						} else {
							if (this.auctionInfo.need_bond != 2) {
								this.$message({
									message: '报名成功',
									type: 'success'
								});
							} else {
								this.auctionInfo.is_enroll = '1'; //新增报名状态更新
								this.auctionInfo.user_enroll = true; //报名成功
							}
						}
					} else {
						this.$message({
							message: res.msg || '',
							type: 'error'
						});
					}
					//hideLoading();
				});
			}

			//缴纳保证金
			if (this.auctionInfo.user_enroll && this.auctionInfo.user_enroll.auction_status == 2) {
				this.$router.replace({
					name: 'cashier',
					params: {
						order_id: this.auctionInfo.user_enroll.id,
						type: 10,
						money: this.auctionInfo.user_enroll.bond_money,
						goodsId: this.goodsId,
						needbond: this.auctionInfo.need_bond
					}
				});
			}
		},
		// 倒计时
		showTimes() {
			let that = this;
			this.interval = setInterval(() => {
				// let [day, hour, minute, second] = [0, 0, 0, 0]
				let nowTime = new Date().getTime();

				let startDate = '';

				if (that.auctionInfo.auction_status == 2) {
					startDate = (that.auctionInfo.end_time_arr ? that.auctionInfo.end_time_arr : that.auctionInfo.end_time) + '';
				} else if (that.auctionInfo.auction_status == 1) {
					startDate = that.auctionInfo.start_time + '';
				}

				startDate = startDate.replace(new RegExp('-', 'gm'), '/');
				let startDateM = new Date(startDate).getTime(); //得到毫秒数
				let lefttime = startDateM - nowTime;
				if (lefttime > 0) {
					that.$set(this.showTime, 'D', Math.floor(lefttime / (1000 * 60 * 60 * 24)));
					that.$set(this.showTime, 'H', Math.floor(lefttime / (1000 * 60 * 60)) - that.showTime.D * 24);
					that.$set(this.showTime, 'M', Math.floor((lefttime / (1000 * 60)) % 60));
					that.$set(this.showTime, 'S', Math.floor((lefttime / 1000) % 60));

					/* this.showTime.D = (this.auctionInfo.end_time_arr && this.auctionInfo.end_time_arr.day) || 0;
					this.showTime.H = (this.auctionInfo.end_time_arr && this.auctionInfo.end_time_arr.hour) || 0;
					this.showTime.M = (this.auctionInfo.end_time_arr && this.auctionInfo.end_time_arr.minute) || 0;
					this.showTime.S = (this.auctionInfo.end_time_arr && this.auctionInfo.end_time_arr.second) || 0; */
				} else {
					that.showTime.D = '00';
					that.showTime.H = '00';
					that.showTime.M = '00';
					that.showTime.S = '00';
					that.auctionTimeStatus = true;
					clearInterval(this.interval);
				}
			}, 1000);
		},

		showTimesPay() {
			// console.log(val)
			let that = this;
			this.interval2 = setInterval(() => {
				// let [day, hour, minute, second] = [0, 0, 0, 0]
				let nowTime = new Date().getTime();
				let startDate = that.auctionInfo.pay_timeout_origin + '';
				startDate = startDate.replace(new RegExp('-', 'gm'), '/');
				let startDateM = new Date(startDate).getTime(); //得到毫秒数
				let lefttime = startDateM - nowTime;
				if (lefttime > 0) {
					that.$set(this.showTime2, 'D', Math.floor(lefttime / (1000 * 60 * 60 * 24)));
					that.$set(this.showTime2, 'H', Math.floor(lefttime / (1000 * 60 * 60)) - that.showTime2.D * 24);
					that.$set(this.showTime2, 'M', Math.floor((lefttime / (1000 * 60)) % 60));
					that.$set(this.showTime2, 'S', Math.floor((lefttime / 1000) % 60));
				} else {
					that.showTime2.D = '00';
					that.showTime2.H = '00';
					that.showTime2.M = '00';
					that.showTime2.S = '00';
					clearInterval(this.interval2);
				}
				this.dialogVisible = true;
			}, 1000);
		},

		handleChange(value) {},
		scrollPrev() {
			// this.ulLeft = 0;
			if (this.currentPicImg == 0) {
				return;
			}
			this.currentPicImg--;
			this.currentImg = this.productImgList[this.currentPicImg];

			if (this.productImgList.length - 4 <= this.currentPicImg) {
				return;
			}

			let num = this.currentPicImg;
			this.ulLeft = -60 * num;
		},
		scrollNext() {
			if (this.productImgList.length - 1 == this.currentPicImg) {
				return;
			}
			this.currentPicImg++;
			this.currentImg = this.productImgList[this.currentPicImg];

			if (this.productImgList.length - 4 <= this.currentPicImg) {
				return;
			}
			let num = this.currentPicImg;
			if (this.productImgList.length <= 5) {
				return;
			}
			this.ulLeft = -60 * num;
			// let num = this.productImgList.length - 5;
			// let left = 60 * num + 24;
			// this.ulLeft = -left;
			// this.isEnd = true;
		},
		addToCart() {
			let data = {
				product_id: this.product.id,
				nums: this.buyNum
			};
			this.$api.addCart(data).then((res) => {
				if (res.status) {
					this.getCartNums();
					this.$router.push({
						path: '/buySuccess',
						query: { goodsName: this.goodsInfo.name }
					});
				} else {
					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			});
		},
		// 获取购物车数量
		getCartNums() {
			this.$api.getCartNum().then((res) => {
				if (res.status) {
					this.getCartNumsAction(res.data);
				}
			});
		},
		//切换评论图片大图
		changeBigImg(img, i, index, item) {
			if (img == item['currentImg']) {
				this.$set(item, 'showBigImg', false);
				this.$set(item, 'currentImg', '');
			} else {
				this.$set(item, 'showBigImg', true);
				this.$set(item, 'currentImg', img);
			}
			this.selectCommentIndex = index;
		},
		//切换显示图片
		changeShowImg(img, idx) {
			this.currentPicImg = idx;

			if (this.productImgList.length > 5) {
				if (idx >= this.productImgList.length - 5) {
					this.ulLeft = -60 * (this.productImgList.length - 5);
				}
			}
			this.currentImg = img;
			this.videoShow = false;
			this.$refs.videoPlayer && this.$refs.videoPlayer.player.pause();
		},
		returnTo(id) {
			document.getElementById(id).scrollIntoView();
		},

		handleScroll() {
			this.scrollTop = this.scrollTop = window.pageYOffset || document.body.scrollTop;
			if (this.scrollTop > 500) {
				this.toTopShow = true;
			} else {
				this.toTopShow = false;
			}
		},
		scrollToTop() {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		// 获取销量排行榜
		getSalesRanking() {
			this.$api.auctionList({ is_rec: 1 }).then((res) => {
				if (res.status) {
					this.saleRanking = res.data.list.splice(0, 6);
				}
			});
		},
		// 相似拍品切换
		prevSimilar() {
			if (this.similarCanPrev) {
				this.similarIndex--;
			}
		},
		nextSimilar() {
			if (this.similarCanNext) {
				this.similarIndex++;
			}
		},
		toDetails(id) {
			let { href } = this.$router.resolve({
				name: 'auction',
				params: { goodsId: id }
			});
			if (!isSafeRedirect(href)) {
				console.warn('非白名单域名，禁止跳转:', href);
				return;
			}
			window.open(href, '_blank');
			// this.reload();
		},
		otherAuction() {
			//跳转拍卖列表
			this.$router.push({
				name: 'auctionlist'
			});
			return;
		},
		//计算当前价和最低价
		calculationCurrent(auctionInfo) {
			//最后一次价格=当前价+加价幅度
			this.last_auction_price = ((Number(auctionInfo.current_price) * 1000 + Number(this.auctionInfo.increase_price) * 1000) / 1000).toFixed(2) - 0;
			//   toDecimal(auctionInfo.current_price)+toDecimal(this.auctionInfo.increase_price);
			//this.last_auction_price = Number(auctionInfo.current_price);

			if (this.current_auction_price < this.last_auction_price) {
				this.current_auction_price = toDecimal(this.last_auction_price).toFixed(2);
			}

			//第一次的时候，当前价为0，所以第一次的时候当前价和最后一次价格一样
			// if (this.current_auction_price > 0 && this.current_auction_price < this.last_auction_price) {
			// 	console.log('2', this.last_auction_price, this.auctionInfo.increase_price);
			// 	this.last_auction_price = this.current_auction_price =
			// 		((Number(this.last_auction_price) * 1000 + Number(this.auctionInfo.increase_price) * 1000) / 1000).toFixed(2) - 0;
			// 	// (toDecimal(this.last_auction_price)+toDecimal(this.auctionInfo.increase_price)).toFixed(2)
			// } else if (this.current_auction_price < this.last_auction_price) {
			// 	console.log('3', this.last_auction_price);
			// 	this.current_auction_price = toDecimal(this.last_auction_price).toFixed(2);
			// }
		},
		monitor() {
			let _this = this;
			setTimeout(() => {
				_this.$refs.table &&
					_this.$refs.table.bodyWrapper.addEventListener(
						'scroll',
						(res) => {
							if (_this.loadScroll) {
								return;
							}
							if (_this.logEND) {
								return;
							}
							let height = res.target;
							let clientHeight = height.clientHeight;
							let scrollTop = height.scrollTop;
							let scrollHeight = height.scrollHeight;
							if (clientHeight + scrollTop + 50 >= scrollHeight) {
								_this.loadScroll = true;
								_this.$api.getofferlog({ ..._this.logForm, auction_id: _this.goodsId }).then((res) => {
									if (res.status) {
										_this.loadScroll = false;
										_this.logForm.page += 1;
										_this.auctionInfo.log = _this.auctionInfo.log.concat(res.data.list);
										if (res.data.list.length < _this.logForm.limit) {
											_this.logEND = true;
										}
									}
								});
							}
						},
						true
					);
			}, 1000);
		},
		getAuctionInfo(id) {
			let data = {
				id
			};

			if (this.$storage.get('userToken')) {
				data.token = this.$storage.get('userToken');
			}
			this.$api.auctionDetails(data).then((res) => {
				if (res.status) {
					this.auctionInfo = res.data;
					this.recordInviteVisit();
					//收藏
					this.isFav = this.auctionInfo.isfav === 'true' ? true : false;
					if (res.data.need_bond == 1) {
						this.tabTitleArr.push({
							id: 'notice',
							name: '保证金须知'
						});
					}
					if (res.data.auction_desc_notice) {
						this.tabTitleArr.push({
							id: 'more',
							name: '拍卖须知'
						});
						this.tabTitleArr.push({
							id: 'msg',
							name: '评论区'
						});
					} else {
						this.tabTitleArr.push({
							id: 'msg',
							name: '评论区'
						});
					}
					// 视频信息（需同时校验 video 对象和字段，避免空数据报错）
					if (this.auctionInfo.video && this.auctionInfo.video.video_url) {
						this.playerOptions.sources[0].src = this.auctionInfo.video.video_url;
						this.playerOptions.poster = this.auctionInfo.video.video_cover || '';
					}
					this.auctionInfo.increase_price = toDecimal(this.auctionInfo.increase_price);

					this.auctionInfo.old_increase_top_price = this.auctionInfo.increase_top_price;
					if (toDecimal(this.auctionInfo.increase_top_price) > 0) {
						this.auctionInfo.increase_top_price = toDecimal(this.auctionInfo.current_price) + toDecimal(this.auctionInfo.increase_top_price);
					} else {
						this.auctionInfo.increase_top_price = 0;
					}

					//无需保证金的时候，直接报名
					if (this.auctionInfo.need_bond == 2 && this.auctionInfo.auction_status == 2) {
						this.submitHandler();
					}
					this.auctionInfo.current_price = toDecimal2(this.auctionInfo.current_price);

					this.num = this.auctionInfo.current_price + this.auctionInfo.increase_price;
					this.currentImg = res.data.images_path[0];

					this.calculationCurrent(this.auctionInfo);
					//拍卖中的，开启连接
					if (this.auctionInfo.auction_status == 2 || this.auctionInfo.auction_status == 1) {
						//竞拍未开始和已开始，都开启socket链接
						this.openWebsocket();
						this.showTimes(); //计算倒计时
					}
					//判断是否竞拍中
					this.getAuctionIsIng(this.auctionInfo['auction_status']);

					this.$nextTick(() => {
						this.showPayInfo(this.auctionInfo);
						//this.showTimes();
						//this.showTimesPay();
					});
					this.monitor();
					this.createPoster();
				}
				hideLoading();
			});
		},
		//显示支付
		showPayInfo(auctionInfo) {
			if (auctionInfo.auction_status == 3 || auctionInfo.auction_status == 4) {
				clearInterval(this.timeoutID); //清理定时器
				this.timeoutID = null;
				this.clearTimeOut = false;
				this.auctionInfo.success_offer_current_user = auctionInfo.success_offer_current_user;
				this.$set(this.auctionInfo, 'auction_success_offer', (auctionInfo && auctionInfo.auction_success_offer) ? auctionInfo.auction_success_offer : {});
				//window.clearInterval(window.timeoutID); //清理定时器
				this.socket && this.socket.close();
				//显示去下单的弹窗
				if (auctionInfo.auction_status == 3 && auctionInfo.success_offer_current_user) {
					this.pay_timeout = auctionInfo.pay_timeout;
					this.auctionInfo.pay_timeout_origin = auctionInfo.pay_timeout_origin;

					// this.status = 1;
					// this.popShow();

					//this.showTimes();
					this.showTimesPay();
				}
			}
		},
		getLastlog() {
			let data = { id: this.auctionInfo.id, last_log_id: this.last_log_id };
			// 如果用户已经登录 要传用户token
			let userToken = this.$storage.get('userToken');
			if (userToken) {
				data['token'] = userToken;
			}
			this.$api.auctionGetLastlog(data).then((res) => {
				let auctionInfo = res.data.info;
				let auctionLog = res.data.log;
				this.showPayInfo(auctionInfo);
				this.getAuctionIsIng(auctionInfo['auction_status']);
				this.auctionInfo.old_increase_top_price = auctionInfo.increase_top_price;
				if (toDecimal(auctionInfo.increase_top_price) > 0) {
					this.auctionInfo.increase_top_price = toDecimal(auctionInfo.current_price) + toDecimal(auctionInfo.increase_top_price);
				} else {
					this.auctionInfo.increase_top_price = 0;
				}
				this.auctionInfo.current_price = auctionInfo.current_price;
				//刷新当前价以及出价记录、和倒计时
				// this.auctionInfo.current_price = auctionInfo.current_price;
				this.calculationCurrent(auctionInfo);

				// this.auctionDetails()

				this.auctionInfo.auction_status = auctionInfo.auction_status;
				this.auctionInfo.end_time_arr = auctionInfo.end_time_arr;
				//this.auctionInfo.user_enroll = auctionInfo.user_enroll;
				//this.auctionInfo.is_enroll = auctionInfo.is_enroll;
				this.auctionInfo.pay_timeout = auctionInfo.pay_timeout;
				this.auctionInfo.pay_timeout_origin = auctionInfo.pay_timeout_origin;
				this.auctionInfo.success_offer_current_user = auctionInfo.success_offer_current_user;
				this.auctionInfo.offer_log_num = auctionInfo.offer_log_num; //延期次数

				if (this.auctionInfo.auction_status == 2) {
					// console.log(12312)
				} else if (this.auctionInfo.auction_status == 3 || this.auctionInfo.auction_status == 4) {
					clearInterval(this.timeoutID); //清理定时器
					this.timeoutID = null;
					// this.clearTimeOut = false;
					//显示去下单的弹窗
					if (this.auctionInfo.auction_status == 3 && this.auctionInfo.success_offer_current_user) {
						setTimeout(() => {
							this.dialogVisible = true;
						}, 1500);
					}
				}

				if (auctionLog.id) {
					this.addAction(auctionLog);
					this.last_log_id = auctionLog.id;
					if (this.auctionInfo.log && auctionLog.userInfo.id != this.auctionInfo.log[0].userInfo.id) {
						this.lastOfferTime = -1; //频繁操作解锁
					}
				}
			});
		},
		//增加出价记录
		addAction(log) {
			if (this.auctionInfo.log.length > 0 && log.id != this.auctionInfo.log[0].id) {
				this.auctionInfo.log.unshift(log);
			} else if (this.auctionInfo.log.length == 0) {
				this.auctionInfo.log.unshift(log);
			}
		},
		//定时查询拍卖最新记录
		timeoutUpdateLog() {
			let _this = this;
			if (this.auctionInfo.auction_status == 2) {
				if (this.timeoutID == null) {
					/* this.timeoutID = setInterval(function() {
						// _this.auctionDetails();
						_this.getLastlog();
					}, 1000); */
					//this.clearTimeOut = false;
				}
			}
		},
		//判断是否竞拍中
		getAuctionIsIng(auction_status) {
			if (auction_status == 2) {
				this.auctionIng = true;
			} else {
				this.auctionIng = false;
			}
		},
		createShareWelfare() {
			if (
				this.$store.state.config.open_auction_share &&
				this.$store.state.config.open_auction_share == 1 &&
				!this.$storage.get('popAuctionShare') &&
				this.sharePoster != ''
			) {
				this.shareWelfare = true;
				this.$storage.set('popAuctionShare', true, 345600);
			}
		},
		notice() {
			let _this = this;
			this.$api.auctionNotice({ auction_id: this.goodsId }).then((res) => {
				_this.$message({
					message: res.msg || '',
					type: 'success'
				});
				if (res.status) {
					_this.auctionInfo.notice = true;
				}
			});
		},
		//下载图片
		savePoster() {
			this.$api.addRecord({
				type: '6',
				api_method: 'savePoster',
				platform: '1',
				code: 'auctionOffer',
				rel_id: this.goodsId
			});
			// 强制下载图片
			const image = new Image();

			// 解决跨域 Canvas 污染问题
			image.setAttribute('crossOrigin', 'anonymous');
			// eslint-disable-next-line func-names
			image.onload = function () {
				const canvas = document.createElement('canvas');
				canvas.width = image.width;
				canvas.height = image.height;
				const context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, image.width, image.height);
				const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
				const a = document.createElement('a'); // 生成一个a元素
				var event = new MouseEvent('click');
				a.download = 'share'; // 设置图片名称
				a.href = url; // 将生成的URL设置为a.href属性
				/* a.click(); */
				a.dispatchEvent(event);
			};

			image.src = this.sharePoster + '?' + new Date().getTime();
		},

		createPoster() {
			let data = {
				page: 13,
				url: `${apiBaseUrl}wap/pages/share/jump`,
				type: 3,
				client: 1
			};
			data.params = {
				id: this.goodsId
			};

			if (this.$storage.get('userToken')) {
				data.token = this.$storage.get('userToken');
			}
			let _this = this;
			this.$api.share(data).then((res) => {
				if (res.status) {
					_this.sharePoster = res.data;
				} else {
					_this.$message({
						message: res.msg || '',
						type: 'error'
					});
				}
			});
		},
		//确认出价
		confirmOffer() {
			this.showAuctionTips = false;
			this.$storage.set('firstEnrollAuction_' + this.goodsId, true);
			this.submitPay();
		},
		//取消出价
		cancleOffer() {
			this.showAuctionTips = false;
			this.$storage.set('firstEnrollAuction_' + this.goodsId, true);
		},
		//切换收藏
		changeFav() {
			let data = {
				goods_id: this.goodsId,
				type: 2
			};
			this.$api.goodsCollection(data).then((res) => {
				if (res.status) {
					this.isFav = !this.isFav;
				}
			});
		},
		//取消消息通知
		cancleSurpassNotice() {
			let data = {
				auction_id: this.goodsId
			};
			let _this = this;
			this.$api.cancleSurpassNotice(data).then((res) => {
				if (res.status) {
					_this.$message({
						message: res.msg || '取消成功',
						type: 'success'
					});
				}
			});
		},
		copyInviteUrl() {
			if (!this.invite) {
				this.$api.shareCode({}).then((res) => {
					if (res.status) {
						this.invite = res.data;
						this.doCopyInviteUrl();
					} else {
						this.$message.warning(res.msg || '获取分享码失败');
					}
				});
				return;
			}
			this.doCopyInviteUrl();
		},
		doCopyInviteUrl() {
			if (!this.inviteUrl) return;
			const text = this.inviteUrl;
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard
					.writeText(text)
					.then(() => {
						this.$message.success('复制成功');
					})
					.catch(() => {
						this.fallbackCopyInviteUrl(text);
					});
			} else {
				this.fallbackCopyInviteUrl(text);
			}
		},
		fallbackCopyInviteUrl(text) {
			const input = document.createElement('input');
			input.value = text;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			this.$message.success('复制成功');
		},
		getUrlParam(paraName) {
			let url = window.location.toString();
			let arrObj = url.split('?');

			if (arrObj.length > 1) {
				let arrPara = arrObj[1].split('&');
				let arr;
				for (let i = 0; i < arrPara.length; i++) {
					arr = arrPara[i].split('=');
					if (arr != null && arr[0] == paraName) {
						if (arr[1].indexOf('#')) {
							let str;
							str = arr[1].split('#');
							return str[0];
						}
						return arr[1];
					}
				}
				return '';
			} else {
				return '';
			}
		}
	},

	mounted() {
		showLoading();

		const _this = this;
		let goodsId = this.$route.params.goodsId;
		let event = this.getUrlParam('event');
		this.goodsId = goodsId;
		this.$api.shareCode({}).then((res) => {
			if (res.status) {
				this.invite = res.data;
			}
		});
		if (this.goodsId) {
			this.getAuctionInfo(this.goodsId);
			this.$api.addRecord({
				type: '1',
				api_method: 'api.details.auction',
				rel_id: this.$route.params.goodsId,
				platform: '1'
			}); //访问记录
			this.$nextTick(function () {
				window.addEventListener('scroll', this.handleScroll);
			});

			this.$nextTick(() => {
				this.qrcode();
			});
			// 获取推荐榜
			this.getSalesRanking();
		}
		if (event && event == 'unsubscribe') {
			this.cancleSurpassNotice();
		}
	},

	beforeDestroy() {
		clearInterval(this.timeoutID); //清理定时器
		this.timeoutID = null;

		clearInterval(this.interval2);
		this.interval2 = null;

		clearInterval(this.interval);
		this.interval = null;
	}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.img-zoom-enter-active,
.img-zoom-leave-active {
	width: 100%;
	transition: all 0.2s linear;
}
.img-zoom-enter,
.img-zoom-leave-to {
	width: 0;
	opacity: 0;
}
.end-status {
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 30px 0;
	.img {
		width: 24px;
		height: 24px;
	}
}

.auction-end-user {
	width: 320px;
	max-width: 400px;
	padding: 0 10px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	background: #ffc300;
	border-radius: 50px;
	font-size: 18px;
	font-weight: bold;
	color: #ffffff;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	.user-txt {
		width: 260px;
		@include no-wrap();
		cursor: pointer;
	}
	.user-avatar {
		width: 34px;
		height: 34px;
		background: #ffffff;
		border: 1px solid #ffffff;
		border-radius: 50%;
		margin-right: 10px;
	}
}
.countdown {
	// margin-top: 24px;
	font-size: 24px;
	font-weight: bold;
	color: #222222;
	display: flex;
	align-items: center;
	span {
		font-size: 14px;
		line-height: 24px;
		color: #666666;
		font-weight: normal;
		margin: 0 5px;
	}
}
.dia {
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: 30px;
	&-title {
		font-size: 24px;
		color: #222222;
		margin-top: 36px;
	}
	&-desc {
		font-size: 14px;
		color: #222222;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	&-btn {
		&-wrap {
			display: flex;
			align-items: center;
		}
		cursor: pointer;
		width: 200px;
		height: 60px;
		line-height: 60px;
		background: #ffc300;
		border-radius: 10px;

		font-size: 24px;
		font-weight: 400;
		color: #fff;
		text-align: center;
		margin-top: 30px;
		margin-bottom: 20px;
		&.cancel {
			margin-right: 20px;
			background: #999999;
		}
	}
}
.scrollTop {
	position: fixed;
	right: 30px;
	bottom: 30px;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background: $theme-color;
	text-align: center;
	color: #fff;
	z-index: 999;
	cursor: pointer;
	.icon {
		display: block;
		margin-top: 12px;
		margin-bottom: 5px;
	}
	p {
		font-size: 12px;
	}
}
.comment {
	display: flex;
	border-bottom: 1px solid $border;
	padding: 15px 0;
	.user {
		display: inline-flex;
		.user-head {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			margin-right: 10px;
			overflow: hidden;
			img {
				display: block;
				width: 40px;
				height: 40px;
				object-fit: cover;
			}
		}
		.user-name {
			display: inline-block;
			color: #757575;
			font-size: 12px;
			width: 75px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
	.detail {
		flex: 1;
		.content {
			padding: 10px 0;
		}
		.img-list {
			margin: 10px 0;
			display: inline-flex;
			.img-li {
				width: 52px;
				height: 52px;
				margin-right: 10px;
				margin-bottom: 5px;
				border: 1px solid $border;
				padding: 2px;
				&.active {
					padding: 1px;
					border: 2px solid $theme-color;
				}
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
		}
		.big-img {
			max-width: 300px;
			border: 1px solid $border;
			padding: 2px;
			&.hidden {
				border: none;
				padding: 0;
			}
			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: contain;
			}
		}
		.time {
			color: #999;
			font-size: 12px;
			margin-top: 10px;
			.addon {
				margin-right: 20px;
			}
		}
	}
}

.wrapper {
	.main {
		padding-top: 14px;
		.t {
			display: flex;
			// padding-bottom: 30px;
			.tl {
				margin-right: 20px;
				.tl-img-box {
					width: 350px;
					height: 350px;
					border: 1px solid $border;
					margin-bottom: 20px;
					position: relative;
					.play-acution {
						position: absolute;
						left: 10px;
						bottom: 10px;
						width: 40px;
						height: 40px;
						z-index: 9;
					}
					.youtube-player {
						position: absolute;
						left: 0;
						top: 0;
						width: 350px;
						height: 350px;
						z-index: 9;
					}
					img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
				.tl-tabs {
					height: 54px;
					position: relative;
					.img-list-box {
						width: 310px;
						height: 54px;
						margin: 0 auto;
						position: relative;
						overflow: hidden;
						padding-bottom: 4px;
						ul {
							position: absolute;
							left: 0;
							top: 0;
							height: 54px;
							transition: left 0.15s linear;
							li {
								width: 60px;
								height: 54px;
								float: left;
								display: flex;
								align-items: center;
								// margin: 0 4px;
								border: 1px solid $border;
								padding: 1px;
								box-sizing: border-box;
								&.active {
									border: 2px solid $theme-color;
									padding: 0;
								}
								&:hover {
									border: 2px solid $theme-color;
									padding: 0;
								}
								img {
									// width: 100%;
									// height: 100%;

									width: 54px;
									height: 54px;

									object-fit: cover;
								}
							}
						}
					}
					.prev {
						position: absolute;
						left: -5px;
						top: 50%;
						width: 26px;
						height: 26px;
						margin-top: -16px;
						cursor: pointer;
						&.disabled {
							cursor: not-allowed;
							.icon {
								color: $border;
							}
						}
						.icon {
							font-size: 26px;
							color: #757575;
						}
					}
					.next {
						position: absolute;
						right: -5px;
						top: 50%;
						width: 26px;
						height: 26px;
						margin-top: -16px;
						cursor: pointer;
						&.disabled {
							cursor: not-allowed;
							.icon {
								color: $border;
							}
						}
						.icon {
							font-size: 26px;
							color: #757575;
						}
					}
				}
			}
			.tr {
				flex: 1;
				position: relative;
				.tr-title {
					font-weight: 700;
					color: #666;
					padding-top: 10px;
					line-height: 28px;
					font-size: 18px;
					margin-bottom: 5px;
				}
				.tr-desc {
					font-size: 14px;
					margin-bottom: 20px;
					line-height: 20px;
				}
				.tr-group {
					margin-bottom: 15px;
					position: relative;
					display: flex;
					padding-left: 20px;
					&.underline {
						padding-bottom: 10px;
						border-bottom: 1px solid $border;
					}
					.tr-title-left {
						color: #838383;
						font-size: 14px;
						display: inline-block;
						min-width: 60px;
						height: 32px;
						line-height: 32px;
						padding-right: 10px;
					}
					.tr-right {
						display: flex;
						flex: 1;
						align-items: center;

						&.input-number {
							align-items: initial;
							flex-direction: column;
							.el-input-number {
								margin-bottom: 20px;
							}
						}
						.now-price {
							color: $theme-color;
							text-align: left;
							margin-right: 20px;
							i {
								font-size: 16px;
							}
							.price-num {
								font-size: 22px;
							}
						}
						.old-price {
							color: #666;
							font-size: 12px;
						}
						.cx-item {
							padding: 2px 4px;
							background: $theme-color;
							color: #fff;
							margin-right: 10px;
							font-size: 12px;
							height: 24px;
							line-height: 24px;
						}
						.color,
						.size {
							font-size: 12px;
							border: 1px solid #b8b7bd;
							margin-right: 8px;
							display: inline-block;
							height: 28px;
							line-height: 28px;
							margin-bottom: 12px;
							&.active {
								border-color: $theme-color;
								background: $theme-color;
								color: #fff;
							}
							a {
								display: block;
								padding: 0 10px;
							}
							&:hover {
								border: 1px solid $theme-color;
							}
						}
						.weight {
							color: #666;
							font-size: 14px;
						}
						.kc {
							color: #878787;
							display: inline-block;
							font-size: 12px;
							margin-left: 20px;
						}
					}
				}
			}
		}
	}
}
.tr-foot {
	display: flex;
	position: absolute;
	bottom: 0;
	.btn {
		height: 45px;
		line-height: 45px;
		font-size: 14px;
		width: 180px;
		text-align: center;
		border: 1px solid $theme-color;
		margin-right: 20px;
		cursor: pointer;
		&.add-btn {
			color: $theme-color;
		}
		&.buy-btn {
			background: $theme-color;
			color: #fff;
		}
		&.sold-out {
			background: $theme-color;
			color: #fff;
			cursor: not-allowed;
			border: none;
		}
	}
}
.collete-btn-auction {
	/*    height: 50px;
    height: 50px;
    text-align: center;
    padding-top: 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
	margin-left: 10px; */

	width: 50px;
	height: 50px;
	border: none;
	margin-left: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	box-sizing: border-box;
	user-select: none;
	cursor: pointer;
	color: #ff7159;
	.icon {
		display: block;
		margin-bottom: 4px;
	}
	&:hover {
		color: $theme-color;
	}
}
.b {
	padding: 20px 0;
	.tabs {
		display: flex;
		align-items: center;
		.tab {
			font-size: 16px;
			padding: 0px 35px;
			cursor: pointer;
			height: 80px;
			line-height: 80px;
			min-width: 169px;
			text-align: center;
			font-size: 18px;
			box-sizing: border-box;
			color: #222;
			border-right: 1px solid #e5e5e5;
			&.active {
				color: $theme-color;
				color: #ff4949;
				background: #fff;
				border-top: 5px solid #ff4949;
				border-radius: none;
			}
		}
	}
	.shop-info-wrap {
		padding: 20px;
		background: #fff;
		width: 856px;
		box-sizing: border-box;
		border: 1px solid #e5e5e5;
		border-top: none;
		.progress {
			border: 10px solid #f6f6f6;
			display: flex;
			align-items: center;
			padding: 20px 18px;
			border-radius: 4px;
			&-title {
				font-size: 18px;
				color: #222222;
				margin-right: 30px;
			}
			&-item {
				font-size: 14px;
				color: #707070;
			}
			img {
				width: 14px;
				height: 14px;
				margin: 0 10px;
			}
		}
		.auction_desc_notice {
			img {
				width: 100%;
			}
		}
		.params-wrap {
			padding: 15px 0;
			h3 {
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				color: #ff4949;
				padding-top: 25px;
				.sign {
					width: 20px;
					height: 35px;
					margin: 0 14px;
					margin-top: 10px;
					&.sign2 {
						transform: rotateY(180deg);
					}
				}
			}
			.params-content {
				padding-left: 20px;
				color: #757575;
				font-size: 12px;
				margin: 10px 0;
			}
		}
		.comment-auction-wrap {
			padding: 15px 0;
			h3 {
				height: 30px;
				line-height: 30px;
				padding-left: 20px;
			}
			.no-comment {
				padding-left: 20px;
				height: 30px;
				line-height: 30px;
			}
			.sub-title {
				text-align: center;
				font-size: 14px;
				color: #222222;
			}
			.ctx-title {
				text-align: center;
				font-size: 24px;
				font-weight: bold;
				color: #222222;
				margin: 20px 0;
			}
			.ctx {
				&-item {
					text-indent: 2em;
					font-size: 14px;
					line-height: 26px;
					color: #222222;
					margin-bottom: 10px;
				}
				&-bot {
					text-align: right;
					margin-bottom: 10px;
				}
			}
			.imp-text {
				color: #ff4949;
			}
		}
	}
}
.leaderboard {
	float: right;
	width: 320px;
	margin-top: -80px;
	border-bottom: 1px solid #e5e5e5;
	background: #fafafa;
	.qrcode {
		width: 204px;
		height: 204px;
		margin-left: 58px;
		margin-top: 40px;
		&-desc {
			font-size: 14px;
			line-height: 24px;
			color: #707070;
			text-align: center;
			margin: 10px 0;
		}
	}
	.title {
		padding: 0 5px;
		text-align: center;
		font-size: 24px;
		color: #222222;
		height: 80px;
		line-height: 80px;
	}
	.board {
		border: 1px solid #e5e5e5;
		border-top: 0;
		.item:last-child {
			border: none;
		}
		.item {
			display: flex;
			justify-content: flex-start;
			padding: 10px 0;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			.number {
				background-color: #333;
				color: #fff;
				width: 20px;
				text-align: center;
				height: 20px;
				line-height: 20px;
			}
			.img {
				width: 280px;
				height: 280px;
				margin-left: 20px;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			.info {
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				.name {
					width: 280px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					color: #222222;
					font-size: 12px;
					line-height: 24px;
					padding: 0 20px;
					margin: 10px 0;
				}
				.price {
					color: #ff7159;
					padding-left: 20px;
					font-size: 24px;
					.txt {
						font-size: 14px;
						color: #222222;
					}
				}
				.sold {
					color: #666;
					font-size: 12px;
					.num {
						color: #ff7159;
					}
				}
			}
		}
	}
}
.shop-container.bgw {
	padding: 20px;
	box-sizing: border-box;
	border: 1px solid #e5e5e5;
	border-radius: 4px;
	width: 1176px;
	position: relative;
	.tr-title {
		margin-bottom: 26px;
		font-size: 20px;
		font-weight: bold;
		display: flex;
		&-tag {
			display: inline-block;
			width: 60px;
			height: 28px;
			background: #fe8d4b;
			opacity: 1;
			border-radius: 4px;
			text-align: center;
			color: #fff;
			line-height: 28px;
		}
	}
}

.mt-auction {
	// width: 783px;
	// height: 190px;
	// background: #F6F6F6;
	position: relative;
	// padding-top: 20px;
	.auction-status {
		position: absolute;
		top: 0;
		right: 12px;
		text-align: center;
		line-height: 20px;
		width: 60px;
		height: 20px;
		background: #ff4949;
		opacity: 1;
		color: #fff;
		border-radius: 0px 0px 4px 4px;
		font-size: 12px;
	}
	.tips {
		font-size: 12px;
		color: #222222;
		margin-top: 20px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		.img {
			width: 16px;
			height: 16px;
		}
	}
	.bot-tips {
		height: 24px;
		line-height: 24px;
		background: #fffcf3;
		border: 1px solid #ffc300;
		border-radius: 2px;
		padding: 6px 12px;
		font-size: 12px;
		span {
			font-weight: bold;
		}
		.img {
			width: 14px;
			height: 14px;
		}
	}
	.el-button {
		width: 180px;
		height: 50px;
		background: #ffc300;
		/* border-radius: 10px; */
		border: none;
		.line1 {
			font-size: 18px;
			color: #fff;
			margin-bottom: 2px;
		}
		.line2 {
			font-size: 12px;
			color: #fff;
		}
	}
}

.mt-list {
	margin: 0 20px;
	&-top {
		font-size: 18px;
		color: #666666;
		margin: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #e5e5e5;
		padding: 16px 0;
		.l {
			display: flex;
			align-items: center;
			.auction-icon {
				width: 18px;
				height: 18px;
				/* background: #ff4949; */
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 5px;
				img {
					widows: 18px;
					height: 18px;
				}
			}
		}
		.r {
			display: flex;
			align-items: center;
			.user {
				font-size: 14px;
				color: #999999;
				position: relative;
				padding: 0 30px;
				&::after {
					content: '';
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 1px;
					height: 14px;
					background: #e5e5e5;
					border-radius: 2px;
				}
				span {
					font-size: 18px;
					color: #666666;
				}
			}
			.user-tips {
				font-size: 14px;
				color: #999999;
				padding-left: 30px;
				padding-right: 20px;
				span {
					font-size: 18px;
					color: #666666;
				}
			}
		}
	}

	&-bot {
		display: flex;
		flex-wrap: wrap;
		.bot-item {
			flex: 0 0 30%;
			font-size: 14px;
			line-height: 24px;
			color: #666666;
			padding: 10px 0;
			border-right: 1px solid #e5e5e5;
			padding-left: 20px;
			&:nth-child(3n) {
				border: none;
			}
			&:nth-child(3n - 2) {
				padding-left: 0;
			}
		}
		.aftersales-desc {
			font-size: 14px;
			line-height: 24px;
			color: #666666;
			padding: 10px 0;
		}
	}
}

.bot-content-wrap {
	width: 1176px;
	margin: 30px auto;
}

// 相似拍品推荐区域
.similar-auc-wrapper {
	max-width: 1176px;
	margin: 30px auto 40px;
	background: #ffffff;
	border-radius: 8px;
	padding: 20px 24px 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	box-sizing: border-box;
	.similar-auc-header {
		display: flex;
		align-items: baseline;
		margin-bottom: 16px;
		.similar-auc-title {
			font-size: 18px;
			font-weight: 600;
			color: #222222;
			margin-right: 12px;
		}
		.similar-auc-sub {
			font-size: 12px;
			color: #999999;
		}
	}
	.similar-auc-content {
		display: flex;
		align-items: center;
		.similar-arrow {
			width: 32px;
			height: 120px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #999999;
			cursor: pointer;
			&.disabled {
				cursor: default;
				opacity: 0.3;
			}
			.icon {
				font-size: 20px;
			}
		}
		.similar-auc-list {
			flex: 1;
			display: flex;
			overflow: hidden;
		}
		.similar-auc-item {
			flex: 0 0 25%;
			box-sizing: border-box;
			padding: 0 10px;
			cursor: pointer;
			transition: transform 0.2s ease;
			&:hover {
				transform: translateY(-2px);
			}
			.img {
				width: 100%;
				height: 200px;
				border-radius: 6px;
				overflow: hidden;
				background: #f5f5f5;
				position: relative;
				img {
					display: block;
					width: 100%;
					height: 100%;
					object-fit: cover;
					object-position: center;
				}
				.similar-status {
					position: absolute;
					left: 0;
					top: 16px;
					width: 90px;
					height: 30px;
					line-height: 30px;
					border-top-right-radius: 30px;
					border-bottom-right-radius: 30px;
					font-size: 14px;
					font-weight: 600;
					text-align: center;
					&.todo {
						color: #ffffff;
						background: #19aa6b;
					}
					&.doing {
						color: #ffffff;
						background: #f44;
					}
					&.done {
						color: #999999;
						background: #f6f6f6;
					}
					&.fail {
						color: #999999;
						background: #f6f6f6;
					}
				}
			}
			.info {
				margin-top: 8px;
				.name {
					font-size: 14px;
					color: #333333;
					/*@include ell();*/
					margin-bottom: 4px;
				}
				.price {
					font-size: 12px;
					color: #ff3d2a;
					.label {
						color: #999999;
						margin-right: 4px;
					}
					.value {
						font-size: 16px;
						font-weight: 600;
					}
				}
			}
		}
	}
}

.tab-btn {
	width: 68px;
	height: 30px;
	border: 1px solid #999999;
	border-radius: 4px;
	font-size: 14px;
	line-height: 20px;
	color: #666666;
	padding: 0;
	&.active {
		background: #ff4949;
		color: #fff;
		border: none;
	}
}

.bgf6 {
	background: #f6f6f6;
}

.pay-btn-wrap {
	margin-top: 40px;
}

.offer-action-link {
	margin-left: 10px;
	font-size: 16px;
	cursor: pointer;
	user-select: none;
	display: flex;
	align-items: center;
	color: #333;

	img {
		width: 17px;
		height: 16px;
		margin-right: 4px;
		flex-shrink: 0;
		vertical-align: middle;
	}
}

.number-box + .pay-btn-wrap {
	margin-top: 0;
}

.tips-fix {
	cursor: pointer;
	//   position: absolute;
	//   right: 0;
	//   top: 20px;
	display: flex;
	align-content: center;
	justify-content: center;
	padding: 0 10px;
	border-left: 1px solid #e5e5e5;
	align-items: center;
	color: #838383;
	text-align: center;
	.img {
		width: 26px;
		height: 26px;
		margin-right: 6px;
	}
	.tips-txt {
		width: 30px;
		font-size: 12px;
		line-height: 15px;
	}
}
.dia-title {
	text-align: center;
}
</style>

<style lang="scss">
.preview-box {
	img {
		height: 350px;
		object-fit: cover;
	}
}

.el-dialog__header {
	// background: #ffc300 !important;
}
.el-dialog__title {
	color: #fff;
	//font-weight: bold;
}
.el-dialog__headerbtn .el-dialog__close {
	color: #fff;
}
.sharePoster .el-dialog__title {
	font-weight: bold;
	color: #303133;
}
.sharePoster .poster-tips {
	text-align: center;
	margin-top: 10px;
}
.sharePoster .dia-btn {
	margin-top: 0px;
	margin-bottom: 0px;
}
#qrcode {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 20px;
}
.qr-txt-wrap {
	border-right: 1px solid #e5e5e5;
	border-bottom: 1px solid #e5e5e5;
}

.qr-txt-wrap ~ .title {
	border-right: 1px solid #e5e5e5;
}

.quesion {
	position: absolute;
	z-index: 10;
	left: 206px;
	top: 10px;
	img {
		width: 20px;
		height: 20px;
	}
}

.quesion2 {
	/* position: absolute; */
	/*  z-index: 10;
  left: 206px;
  top: 10px; */
	img {
		width: 20px;
		height: 20px;
	}
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
	height: 100% !important;
}

#detail .video-j-js {
	display: initial;
}
.el-tag {
	margin-right: 5px;
}
.showAuctionTips .dia-desc {
	display: inline-flex;
}
.showAuctionTips .dia-content {
	text-align: center;
}
.showAuctionTips .dia-desc .dia-btn {
	width: 120px;
	height: 60px;
	line-height: 60px;
}
.showAuctionTips .dia-desc .cancle {
	border: #ffc300 2px solid;
	background-color: #fff;
	color: #666666;
	font-weight: 500;
	box-sizing: border-box;
	margin-left: 20px;
}
.swiper-box {
	position: relative;
	.des {
		position: absolute;
		bottom: 10px;
		right: 10px;
		height: 22px;
		background-color: rgba(0, 0, 0, 0.6);
		color: #fff;
		font-size: 13px;
		padding: 2px 10px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		> img {
			width: 12px !important;
			height: 12px;
			margin-right: 3px;
		}
	}
}
.shop-info-item {
	p {
		line-height: 1.75em;
	}
}
.auto-offer-dialog {
	padding: 10px 20px;
}
</style>
